import { Link } from 'react-router-dom';
import { stats } from '@/mocks/articles';

export default function AboutBrand() {
  return (
    <section className="w-full bg-background-100 pt-24 pb-16 md:pt-32 md:pb-24">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8" aria-label="面包屑导航">
          <Link to="/" className="hover:text-accent-500 transition-colors">首页</Link>
          <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center" />
          <span className="text-foreground-700 font-medium">关于我们</span>
        </nav>

        <div className="flex flex-col lg:flex-row lg:items-start gap-8 lg:gap-16">
          <div className="lg:w-2/5">
            <p className="text-xs text-foreground-500 font-medium mb-3 tracking-wide uppercase">
              关于 · 吃瓜网黑料
            </p>
            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight">
              关于<span className="text-accent-500">我们</span>
            </h1>
            <p className="mt-5 text-foreground-500 text-sm leading-relaxed max-w-md">
              吃瓜网黑料成立于2024年，是51吃瓜网黑料网站旗下的核心内容平台。我们聚焦网红塌房、黑料合集与国产精品爆料内容，致力于为吃瓜群众提供最新、最全、最真实的一手资讯。
            </p>
            <p className="mt-3 text-foreground-500 text-sm leading-relaxed max-w-md">
              我们的团队由资深媒体人、调查记者和数据分析师组成，秉持"真实爆料、理性吃瓜"的理念，深度追踪每一条网红翻车线索，让每一个瓜都有据可查。
            </p>

            <div id="contact" className="mt-8 flex flex-col gap-3">
              <h4 className="text-sm font-semibold text-foreground-950">联系我们</h4>
              <p className="text-sm text-foreground-500">
                <i className="ri-mail-line mr-1.5 w-4 h-4 inline-flex items-center justify-center" />
                爆料邮箱：tips@chigua.example.com
              </p>
              <p className="text-sm text-foreground-500">
                <i className="ri-wechat-line mr-1.5 w-4 h-4 inline-flex items-center justify-center" />
                微信公众号：吃瓜网黑料
              </p>
              <p className="text-sm text-foreground-500">
                <i className="ri-tiktok-line mr-1.5 w-4 h-4 inline-flex items-center justify-center" />
                抖音号：@chiguawang
              </p>
            </div>
          </div>

          <div className="lg:w-3/5 flex gap-4">
            <div className="w-2/5 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20office%20workspace%20with%20team%20silhouettes%2C%20warm%20cream%20and%20coral%20tones%2C%20minimalist%20design%2C%20collaborative%20atmosphere%2C%20soft%20natural%20light%2C%20professional%20creative%20environment&width=600&height=500&seq=about-team&orientation=portrait"
                alt="吃瓜网黑料团队"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-3/5 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Creative%20digital%20media%20workspace%20with%20multiple%20screens%2C%20editorial%20style%2C%20warm%20cream%20background%2C%20modern%20minimalist%20office%2C%20newsroom%20atmosphere%2C%20professional%20setup&width=900&height=500&seq=about-office&orientation=portrait"
                alt="吃瓜网黑料办公环境"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}